export const cores = {
  primario: '#534AB7',
  fundo: '#F8F7FF',
  card: '#EEEDFE',
  roxoEscuro: '#3C3489',
  sucesso: '#1D9E75',
  alerta: '#EF9F27',
  erro: '#E24B4A',
  erroFundo: '#F7C1C1',
  texto: '#2C2C2A',
  textoSecundario: '#888780',
  textoTerciario: '#B4B2A9',
  branco: '#FFFFFF',
};
